import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

const Page = ({ title, children }) => (
  <div className="min-h-screen flex flex-col bg-background">
    <Header />
    <div className="px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto py-12 flex-1">
      <h1 className="font-display text-3xl font-extrabold text-navy-800 mb-8">{title}</h1>
      <div className="prose prose-slate max-w-none space-y-5 text-slate-600 leading-relaxed">{children}</div>
    </div>
    <Footer />
  </div>
);

export function Terms() {
  return (
    <Page title="Terms of Service">
      <p>Safety Jobs operates a U.S.-only job board for safety-related roles. By using the platform you agree to these terms.</p>
      <H>Employer listings</H>
      <p>Employers pay $99 for a 60-day job listing. Listings publish immediately after successful payment and expire 60 days later. Safety Jobs may unpublish, suspend, or flag any listing at its discretion for compliance reasons.</p>
      <H>Applicant memberships</H>
      <p>Applicants may browse all jobs for free. A $10 membership grants unlimited applications for 30 days. Memberships are non-transferable.</p>
      <H>Refunds</H>
      <p>Refunds may be issued by Safety Jobs on a case-by-case basis. Contact us within 14 days of purchase for refund requests.</p>
      <H>Acceptable use</H>
      <p>Postings must be genuine safety-related U.S. roles. Fraudulent, discriminatory, or non-compliant listings will be removed.</p>
    </Page>
  );
}

export function Privacy() {
  return (
    <Page title="Privacy & Consent">
      <p>We collect the information you provide to operate the job board: account details, job listings, applicant profiles, resumes, and cover letters.</p>
      <H>Resume storage & forwarding consent</H>
      <p>When you apply, you consent to Safety Jobs storing your resume and cover letter and forwarding them to the employer's hiring contact by email and dashboard. Retained files allow us to re-deliver an application if an email fails.</p>
      <H>Payments</H>
      <p>Payments are processed securely by Stripe. We do not store your card details.</p>
      <H>Data requests</H>
      <p>You may request deletion of your stored resume and profile at any time by contacting us.</p>
    </Page>
  );
}

const H = ({ children }) => <h3 className="font-display text-lg font-bold text-navy-800 !mt-8">{children}</h3>;
